export default theme => ({
  header: {
    boxSizing: 'border-box',
    height: 50,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid',
    borderBottomColor: theme.colors.grey[100]
  },
  title: {
    margin: '0 30px',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& h1': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },
  headerActions: {
    height: '100%',
    display: 'flex'
  },
  leftButton: {
    width: '109px',
    border: '0',
    height: '100%',
    borderRadius: '0',
    borderLeft: '1px solid',
    borderLeftColor: theme.colors.grey[100],
    textTransform: 'uppercase',
    '& span': {
      fontSize: 11
    }
  },
  saveButton: {
    border: '0',
    height: '100%',
    minWidth: '110px',
    borderRadius: '0',
    textTransform: 'uppercase',
    '& span': {
      fontSize: 11
    }
  }
});